<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1 v-if="experience.id">{{$t('modals.edit_work_experience.title')}}</h1>
            <h1 v-else>{{$t('modals.create_work_experience.title')}}</h1>
        </div>

        <work-experience-form
            :experience="experience"
            :wrapperClass="['modal__content']"
            @saved="onExperienceUpdate">

            <div class="modal__footer" slot="buttons" slot-scope="{ isSaveDisabled }">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                    <button class="actions__action--cancel" type="button" @click="refetchAndClose">{{$t('modals.common.cancel')}}</button>
                </div>
            </div>
        </work-experience-form>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import WorkExperienceForm from '@/components/forms/dashboard/WorkExperienceForm';

    import { GET_WORK_EXPERIENCE } from '@/store/modules/work-experience';

    @Component({
        components: {
            WorkExperienceForm,
        }
    })
    export default class WorkExperienceModal extends Vue {
        name = 'work-experience-modal';

        experience = {};

        beforeOpen(event) {
            if (event.params && event.params.experience) {
                this.experience = event.params.experience;
            }
        }

        onExperienceUpdate(trajectory) {
            this.$notify.success(this.$t('notify.work_experience.save_success'));
            this.refetchAndClose();
        }

        refetchAndClose() {
            this.$store.dispatch(GET_WORK_EXPERIENCE, {});
            this.$modal.hide(this.name);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/dashboard/WorkExperienceModal.vue